import { Component } from 'react';
import PropTypes from 'prop-types';
/* eslint-disable react/prefer-stateless-function,react/no-unused-prop-types */
export default class TreeNode extends Component {
}
TreeNode.propTypes = {
    /**
     * 选项值
     */
    value: PropTypes.any,
    /**
     * 显示值
     */
    title: PropTypes.any,
};
TreeNode.__PRO_TREE_SELECT_NODE = true;
